module.exports = __webpack_public_path__ + "static/media/top.9379653e.jpeg";